<div class="max-w-3xl mx-auto w-full">
    @if (isSnowflakeSection() && isCreate()) {
        <div class="rounded-lg bg-blue-50 dark:bg-blue-900/20 relative p-4 mb-4 overflow-hidden" role="status">
            <div class="absolute w-1 h-full left-0 top-0 bottom-0 bg-blue-500 dark:bg-blue-400"></div>
            <p class="text-sm text-light-textColor dark:text-dark-textColor pl-2">
                {{ 'workflow.snowflake.info-message' | translate }}
            </p>
        </div>
    }

    @if (stepConfig().fields.length && (!isSnowflakeSection() || isCreate())) {
        <div class="flex flex-col gap-4">
            @for (field of nonProductFields(); track field.name) {
                <app-workflow-field [field]="field" [control]="fieldControls()[field.name]"> </app-workflow-field>
            }
        </div>
    }
</div>

<!-- Product table: full available width -->
@if (productRelevantFields().length && (!isSnowflakeSection() || isCreate())) {
    <app-product-table
        class="block w-full mt-4"
        [productFields]="productRelevantFields()"
        [productsForm]="productsForm()"
        [stepForm]="stepForm()"
        [disabled]="disabled()"
    />
}

<!-- Snowflake search: constrained to max-w-3xl -->
@if (isSnowflakeSection()) {
    <div class="max-w-3xl mx-auto w-full">
        @if (isCreate()) {
            <app-snowflake-search [stepForm]="stepForm()" [stepConfig]="stepConfig()" [disabled]="disabled()" />
        } @else {
            <div class="rounded-lg bg-amber-50 dark:bg-amber-900/20 relative p-4 overflow-hidden" role="status">
                <div class="absolute w-1 h-full left-0 top-0 bottom-0 bg-amber-500 dark:bg-amber-400"></div>
                <p class="text-sm text-light-textColor dark:text-dark-textColor pl-2">
                    {{ 'workflow.snowflake.create-only-message' | translate }}
                </p>
            </div>
        }
    </div>
}
